<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <a-card class="m-wrong" v-if="id === null || id === undefined">
      <m-anim :options="notfound" class="anim" :height="getScreen ? 200 : 500" :width="getScreen ? 200 : 500"></m-anim>
      <h3>>Not Found</h3>
      <p>Return to the previous page and make the selection manifest again!</p>
      <a-button type="primary" block>
        <router-link to="/po">
          <a-icon type="rollback" />&nbsp; Return
        </router-link>
      </a-button>
    </a-card>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading" class="margin-bottom">
            <div slot="title">
              Pencairan Financing Manifest
              <small class="m-display-block m-text-small">
                {{ manifest.header.no_transaksi }}
              </small>
            </div>
            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title">Tanggal Permohonan</span>
                  <span class="m-list-desc">{{
                    manifest.header.tanggal_permohonan
                    ? moment(
                      manifest.header.tanggal_permohonan,
                      getStandartFormatDate
                    ).format(getDefaultDateFormat)
                    : "-"
                  }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title">User Creator</span>
                  <span class="m-list-desc">{{ manifest.header.user_creator }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title">Cost Center</span>
                  <span class="m-list-desc">{{ manifest.header.cost_center ? manifest.header.cost_center : "-" }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title">Value</span>
                  <span class="m-list-desc">{{
                    formatCurrency("IDR", manifest.header.value_pencairan)
                  }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title">Description</span>
                  <span class="m-list-desc">{{ manifest.header.description }}
                  </span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-card title="Pembayaran Hutang" class="margin-top">
            <a-table rowKey="id_penarikan_financing_dtl" :columns="columns" :dataSource="manifest.detail"
              :pagination="pagination" size="small" bordered :scroll="{ x: 1300 }">
              <div slot="no" slot-scope="item, record, index">
                {{ index + 1 }}
              </div>
              <a @click="handleDetail(item)" slot="bulan_tahun" slot-scope="item">
                {{ item.bulan_tahun }}
              </a>
              <div slot="pokok" slot-scope="item">
                <CurrencyJustified :currencyValue="item.currency" :valueNumber="parseFloat(item.pokok)" />
              </div>
              <div slot="bunga" slot-scope="item">
                <CurrencyJustified :currencyValue="item.currency" :valueNumber="parseFloat(item.bunga)" />
              </div>
              <div slot="total_value" slot-scope="item">
                <CurrencyJustified :currencyValue="item.currency" :valueNumber="parseFloat(item.total_value)" />
              </div>
            </a-table>
          </a-card>
        </a-col>

        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">File Attachment</h4>
                <div>
                  <a-button @click="addLampiran" type="default" size="small" class="margin-right-small"
                    :disabled="manifest.can_upload === 'enabled' ? false : true"
                    v-if="!getIsSpecialMenu"
                    >
                    upload
                    <a-icon type="upload" />
                  </a-button>
                </div>
              </div>
              <a-list itemLayout="horizontal" :dataSource="manifest.lampiran">
                <Empty v-if="manifest.lampiran
                    ? manifest.lampiran.length <= 0
                    : manifest.lampiran
                  " />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title">
                      <a @click="handleDownload(item)" class="margin-remove m-text-dots">
                        {{ item.jenis ? item.jenis : "-" }}
                      </a>
                    </div>
                    <div slot="description">
                      <div class="m-display-flex space-between nowrap">
                        <h4 class="margin-remove m-text-dots">
                          {{ item.fungsi }}
                        </h4>
                      </div>
                      {{ item.tanggal }} | {{ item.tlc }}
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Related Document</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="manifest.related_document">
                <Empty v-if="manifest.related_document
                    ? manifest.related_document.length <= 0
                    : manifest.related_document
                  " />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-middle">
                      <a @click="handleView({ ...item, id_manifest: item.id })">{{ item.header }}</a>
                      <Status :class="!getScreen ? 'margin-remove' : ''" :status="item.status" />
                    </div>
                    <template slot="description">
                      <div>{{ item.no_trans }}</div>
                      <div>{{ formatCurrency(item.currency, item.value) }}</div>
                      <div>{{ item.tgl }}</div>
                    </template>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <a-modal centered v-model="previewVisible" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Payment </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="payment in selectedDetail" :key="payment.id">
          <div class="m-display-flex space-between">
            <h3 class="margin-remove m-list-title">
              <router-link :to="{
                name: 'PaymentScheduleManifestKeu',
                params: { id: payment.id },
              }">
                {{ payment.no }} | {{ payment.tlc }}
              </router-link>
            </h3>
          </div>
          <div class="m-display-flex space-between">
            <span class="margin-remove m-list-desc">
              Pokok
              {{ formatCurrency("IDR", payment.pokok ? payment.pokok : 0) }}
              | Bunga
              {{ formatCurrency("IDR", payment.bunga ? payment.bunga : 0) }}
            </span>
          </div>
          <div class="m-display-flex space-between">
            <span class="margin-remove m-list-desc">
              {{ moment(payment.create_dt).format(getDateTimeFormat) }}
            </span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal v-model="visibleLampiran" @ok="addLampiran" :footer="null" @cancel="cancelLampiran">
      <span slot="title">
        <a-icon type="reload" />&nbsp;Upload Attachments
      </span>

      <a-form :form="formLampiran">
        <a-form-item label="Document Type">
          <a-select v-decorator="['jenis', { rules: [{ required: true }] }]">
            <a-select-option value="Other">Other</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Document Description">
          <a-input autocomplete="off" v-decorator="['fungsi', { rules: [{ required: true }] }]"></a-input>
        </a-form-item>

        <a-form-item label="Upload Document File">
          <a-upload :remove="handleRemove" v-decorator="[
            'file_list_lampiran',
            { rules: [{ required: true }] },
          ]" :disabled="fileListLampiran.length > 0" :beforeUpload="beforeUpload">
            <a-button> <a-icon type="upload" />Select File </a-button>
          </a-upload>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button @click="handleUploadLampiran" block type="danger" html-type="submit">Save</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
import moment from "moment";
import _ from "lodash";
import Axios from "axios";

export default {
  name: "FinancingManifest",
  components: {
    Status,
    "m-anim": lottie,
  },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute],
  data() {
    const columns = [
      {
        title: "#",
        align: "left",
        width: 25,
        scopedSlots: { customRender: "no" },
      },
      {
        title: "Tempo Pembayaran",
        width: 250,
        scopedSlots: { customRender: "bulan_tahun" },
      },
      {
        title: "No BKK",
        width: 150,
        dataIndex: "no_bkk",
      },
      {
        title: "Pokok",
        width: 150,
        scopedSlots: { customRender: "pokok" },
      },
      {
        title: "Bunga",
        width: 150,
        scopedSlots: { customRender: "bunga" },
      },
      {
        title: "Total Value",
        width: 150,
        scopedSlots: { customRender: "total_value" },
      },
    ];
    return {
      columns,
      notfound: { animationData: notfound, loop: true },
      previewVisible: false,
      previewImage: "",
      loading: false,
      visibleHistory: false,
      manifest: {
        header: {},
        lampiran: [],
        can_upload: "",
      },
      selectedDetail: {},
      pagination: {
        onChange: (page) => { },
        pageSize: 5,
        size: "small",
      },
      visibleLampiran: false,
      fileListLampiran: [],
    };
  },
  beforeCreate() {
    this.formLampiran = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
    ]),
  },
  methods: {
    moment,
    fetchManifest() {
      this.$store
        .dispatch("getManifestPenarikanFinancing", {
          id: this.id,
          auth: this.getAuth,
        })
        .then((result) => {
          this.manifest = {
            header: result.header[0],
            detail: result.dtl,
            related_document: result.related_dokumen,
            lampiran: result.file_attachment,
            can_upload: result.can_upload,
          };
        });
    },
    handleDetail(item) {
      this.$store
        .dispatch("getDetailHistoryPenarikan", {
          id: item.id_penarikan_financing_dtl,
          auth: this.getAuth,
        })
        .then((res) => {
          this.selectedDetail = res.bukti_tf;
          this.previewVisible = true;
        });
    },
    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;
    },
    cancelLampiran() {
      this.fileListLampiran = [];
      this.formLampiran.resetFields();
    },
    handleRemove(file) {
      const index = this.fileListLampiran.indexOf(file);
      const newFileList = this.fileListLampiran.slice();
      newFileList.splice(index, 1);
      this.fileListLampiran = newFileList;
    },

    beforeUpload(file, fileList) {
      if (this.fileListLampiran.length < 1) {
        const FileSize = file.size / 1024 / 1024;
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          // if (this.data.jenis === "Transfer") {
          //   this.fileList.push(file);
          // } else {
          this.fileListLampiran.push(file);
          //}
          return false;
        }
      } else {
        return true;
      }
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.path, "_blank");
    },
    handleUploadLampiran() {
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        if (values.file_list_lampiran.fileList.length == 0) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_penarikan_financing", this.id);
        formData.append("fungsi", values.fungsi);
        formData.append("jenis", values.jenis);
        formData.append("tlc", this.getAuth.username);
        formData.append("nama_document", values.file_list_lampiran.file);

        Axios({
          method: "post",
          url: this.$serviceUrl + "penarikan_financing/upload_lampiran",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-upload");
            this.visibleLampiran = !this.visibleLampiran;
            this.$router.go(0);
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
  },
  async mounted() {
    await this.fetchManifest();
  },
};
</script>

<style></style>
